import { schema } from 'normalizr';
import { EntityTypes } from '@/api/types/entities';

export const channelPhoneSchema = new schema.Entity(EntityTypes.Phone);
